import {
	SatisfactionLevelTypes,
	TrendsTypes,
} from 'modules/admin-panel/pages/results/models/Types';

export enum Modes {
	grid = 'grid',
	map = 'map',
	expandedGrid = 'expandedGrid',
}

export enum StatisticGroupingTypes {
	location = 'location',
	role = 'role',
	businessUnit = 'businessUnit',
}

export type IRateType = TrendsTypes | SatisfactionLevelTypes;
